import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import {
    requestExpertAssist,
    RequestExpertAssistApiModel,
    RequestExpertAssistModel,
} from "@tCentro/Services/CENExpertAssistService";

export interface RequestExpertAssistParameter extends HasOnSuccess<RequestExpertAssistModel>, HasOnError<string> {
    model: RequestExpertAssistApiModel;
}

type HandlerType = ApiHandler<RequestExpertAssistParameter, { apiResult: RequestExpertAssistModel }>;

export const RequestExpertAssist: HandlerType = async props => {
    try {
        const result = await requestExpertAssist(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to request expert assist");
        }
    }
};

export const chain = [RequestExpertAssist];
const requestExpertAssistData = createHandlerChainRunner(chain, "requestExpertAssistData");
export default requestExpertAssistData;